module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/Pompeii.3152f35.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/Pompeii.jpg
// module id = gkLn
// module chunks = 0